import React from "react";
import { connect } from "react-redux";
import "../assets/ak-cached/24h/css/channelLineup.css";
import * as ChannelBackend from "../action/channelLineup";
import AutoComplete from "react-autocomplete";
import { loaderActive } from './../action/loder';
import Loader from './loader';
import ReactHtmlParser from 'react-html-parser';
import ChannelLineup from "./channelLineup";
import { InHomeUtils } from "../util/change/inhomeUtils";

class ChannelLineupMaster extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCounty: this.props.isChangeFlow ? (this.props.signIn.response && this.props.signIn.response.accountAddress && this.props.signIn.response.accountAddress.city) ? this.props.signIn.response.accountAddress.city: "" : (this.props.lqState.selectedState && this.props.lqState.selectedState.city) ? this.props.lqState.selectedState.city: "",
      county: "",
      isOpen: false
    };
    this.window = React.createRef();    
  }

  componentDidMount() {
    loaderActive({ isLoaderActive: true }, this.props.dispatch);
    let profileTvProduct = (this.props.profileCart && this.props.profileCart.ProfileTVProduct) ? this.props.profileCart.ProfileTVProduct : null;
    ChannelBackend.clearSearchChannelProgram(this.props.dispatch);
    ChannelBackend.clearSelectedPkgs(this.props.dispatch);
    ChannelBackend.getLFA(
      this.props.appState.visitId,
      this.props.appState.visitorId,
      this.props.flowType==="SUPP"? (this.props.isChangeFlow)? this.props.signIn.response.tarCode :this.props.lqState.selectedState.tarCode : (this.props.isChangeFlow)? this.props.signIn.response.tarCode: this.props.lqState.lqResponse.tarCode,
      (this.props.isChangeFlow)? (this.props.signIn.response && this.props.signIn.response.zipCode)? this.props.signIn.response.zipCode : "" : (this.props.lqState.selectedState && this.props.lqState.selectedState.zip) ? this.props.lqState.selectedState.zip : "",
      "",
      this.props.customonly,
      this.props.dispatch,
      (this.props.isChangeFlow) ? true: false,
      (this.props.isChangeFlow) ? InHomeUtils.isNotNull(profileTvProduct) ? profileTvProduct.prodId :"": "",
      (this.props.isChangeFlow) ? (this.props.signIn && this.props.signIn.response && (this.props.signIn.response.classicToFcp || (this.props.signIn.response.userProfile && this.props.signIn.response.userProfile.isFcpInProfile))) ? true : false : false
    );
  }

  searchChannels = event => {
    ChannelBackend.clearSelectedPkgs(this.props.dispatch);
    let newSearchValue = event.target.value;
    this.setState({isOpen: true});
    ChannelBackend.getChannels(
      this.props.appState.visitId,
      this.props.appState.visitorId,
      this.props.channelLineupState.vhoList[0].lfa,
      "",
      newSearchValue,
      this.props.dispatch
    );
  };

  CountyOnChange = event => {
    event.persist();
    let newZipValue = event.target.value;
    this.setState({ selectedCounty: event.target.value });
    if (newZipValue.length === 5) {
      ChannelBackend.getLFA(
        this.props.appState.visitId,
        this.props.appState.visitorId,
        "",
        newZipValue,
        "NC",
        this.props.customonly,
        this.props.dispatch
      );
      setTimeout(() => {
        if (this.props.channelLineupState.vhoList.length === 1) {
          event.target.value = this.props.channelLineupState.vhoList[0].lfaname;
        }
      }, 700);
    }
  };

  inputOnFocus = event => {
    if (event.target.value) {
      event.target.value = this.props.channelLineupState.vhoList[0].zip;
    }
  };
  inputOnBlur = event => {
    event.target.value = this.props.channelLineupState.vhoList[0].lfaname;
  };

  countySelection = event => {
    loaderActive({ isLoaderActive: true }, this.props.dispatch);
    const countySelected = event.target.innerHTML;
    this.setState({
      selectedCounty: countySelected
    });
    const el = document.body.querySelector("input[name='county']");
    const vhoname = event.target.getAttribute("vhoname");
    const lfa = event.target.getAttribute("lfa");
    el.value = countySelected;
    ChannelBackend.countySelected(countySelected, this.props.dispatch);
    ChannelBackend.getPackages(
      this.props.appState.visitId,
      this.props.appState.visitorId,
      "",
      lfa,
      "",
      vhoname,
      this.props.customonly,
      this.props.dispatch
    );
  };

  packageClick = event => {
    const selectedPkgs = this.props.channelLineupState.selectedPkgs;
    var target = event.target;
    if (event.target.nodeName === "SPAN") {
      // Get the parent.
      target = event.target.parentElement;
    }
    const selected = target.getAttribute("packageid");
    if (selectedPkgs.includes(selected)) {
      // DESELECT ELEMENT
      ChannelBackend.deselectPackage(
        selectedPkgs,
        selected,
        this.props.dispatch
      );
      target.classList.remove("selectedPkg");
    } else if (selectedPkgs.length < 2) {
      ChannelBackend.selectPackage(selectedPkgs, selected, this.props.dispatch);
      target.classList.add("selectedPkg");
    }
  };

  packageCompareClick = event => {
    const selectedPkgs = this.props.channelLineupState.selectedPkgs;
    var selected = "";
    var row = "";
    if (
      event.target.nodeName === "TD" &&
      event.target.parentElement.nodeName === "TR"
    ) {
      // Get the parent.
      row = event.target.parentElement;
      selected = row.getAttribute("packageid");
    } else if (event.target.nodeName === "SPAN") {
      row = event.target.parentElement.parentElement;
      selected = row.getAttribute("packageid");
    } else {
      row = event.target;
      selected = row.getAttribute("packageid");
    }

    if (selectedPkgs.includes(selected)) {
      // DESELECT ELEMENT
      ChannelBackend.deselectPackage(
        selectedPkgs,
        selected,
        this.props.dispatch
      );
      row.classList.remove("selectedPkg");
    } else if (selectedPkgs.length < 2) {
      ChannelBackend.selectPackage(selectedPkgs, selected, this.props.dispatch);
      row.classList.add("selectedPkg");
    }
  };

  channelProgramClick = selected => {
    const dropdownResults = this.props.channelLineupState.searchDropdown;
    var selectedChannelPrograms = this.props.channelLineupState
      .selectedChannelPrograms;

    this.setState({isOpen: false})

    // If there are no selected channels/programs
    if (selectedChannelPrograms === undefined) {
      selectedChannelPrograms = [];
    }

    // Check if that no more than 4 packages have been selected
    if (
      selectedChannelPrograms.length >= 4 ||
      selectedChannelPrograms.some(e => e.channelname === selected)
    ) {
      ChannelBackend.clearSearchChannelProgram(this.props.dispatch);
      return;
    }

    // Search for selected in dropdownResults
    var newSelection = dropdownResults.find(item => {
      return item.name === selected;
    });

    // Clear input box
    ChannelBackend.clearSearchChannelProgram(this.props.dispatch);

    // Run API -> Will update this.props.channelLineupState.channelProgramResults
    ChannelBackend.getChannelResults(
      this.props.appState.visitId,
      this.props.appState.visitorId,
      this.props.channelLineupState.vhoList[0].lfa,
      this.props.channelLineupState.vhoList[0].vhoname,
      newSelection.elkchannelname,
      newSelection.name,
      newSelection.channelid,
      newSelection.type,
      newSelection.programid,
      "",
      selectedChannelPrograms,
      this.props.channelLineupState.packageList,
      this.props.dispatch
    );
  };

  closeChannelClick = event => {
    const close = event.target.getAttribute("channelno");
    const selectedChannels = this.props.channelLineupState
      .selectedChannelPrograms;
    ChannelBackend.removeChannel(
      selectedChannels,
      close,
      this.props.channelLineupState.packageList,
      this.props.dispatch
    );
    this.window.current.scrollTo(0, 0);
  };

  clearChannelsClick = event => {
    ChannelBackend.clearSelectedChannels(this.props.dispatch);
  };

  viewChannelLineup = () => {
    ChannelBackend.displayChannelLineup(this.props.dispatch);
  };

  viewMaster = () => {
    ChannelBackend.displayCLUMaster(this.props.dispatch);
  };

  render() {
    let value = this.props.channelLineupState.searchValue
    const {isOpen} = this.state
    let mainContent = "";
    let domain=window.location.origin;
    let cluRedux = this.props.channelLineupState;
    let message = <h6 className="message"> {cluRedux.message}</h6>;
    let ecTarCode = "";
    let ecZipCode = ""
    if (this.props.signIn != null && this.props.signIn.response != null) {
      ecTarCode = this.props.signIn.response.tarCode;
      ecZipCode = this.props.signIn.response.zipCode;
  }

    let gotoCLU = (
      <button
        className={
          this.props.channelLineupState.selectedPkgs.length === 0
            ? "gotoCLU hide"
            : "gotoCLU"
        }
        onClick={this.viewChannelLineup}
      >
        {this.props.channelLineupState.selectedPkgs.length === 1
          ? "View All Channels"
          : "Compare Channels"}
      </button>
    );

    // if nothing is being searched -> show packages
    // if something searched but no dropdown results -> Update message & don't show packages
    // if nothing is being searched & there are program/channel results -> show table
    if (
      cluRedux.searchValue === "" &&
      cluRedux.packageList &&
      cluRedux.selectedChannelPrograms.length <= 0
    ) {
      let packageList = cluRedux.packageList.map((pkg, index) => {
        return (
          <button
            key={index}
            onClick={this.packageClick}
            tabIndex="0"
            packageid={pkg.packageusoc}
            className={ cluRedux.selectedPkgs.includes(pkg.packageusoc) ? "package selectedPkg" : "package" }
          >
          {ReactHtmlParser(pkg.packagename)}
            
            <br />
            <span>{pkg.totalchannelcount}+ channels</span>
          </button>
        );
      });

      mainContent = <div className="channelList">{packageList}</div>;
    } else if (
      cluRedux.selectedChannelPrograms.length > 0 &&
      cluRedux.searchValue === ""
    ) {
      var selectedChannelPrograms = cluRedux.selectedChannelPrograms;
      if (selectedChannelPrograms.length >= 4) {
        message = (
          <h6 className="message">
            <button
              style={{ textDecoration: "underline" }}
              onClick={this.clearChannelsClick}
            >
              Clear selection(s) to search again
            </button>
          </h6>
        );
      } else {
        message = <h6 className="message"> {cluRedux.message}</h6>;
      }

      var channelProgramList = selectedChannelPrograms.map(channel => {
        return (
          <th key={channel.channelno} className="channelCompare">
            {
              channel.channellogourl ? 
              <img
              src={
                (channel.type === "C" || channel.type === "P")
                  ? domain + "/content/dam/verizon/personal/cluimages/" +
                    channel.channellogourl
                  : "https://hydracdnssl.verizon.net/ResourcesFiles/ImageLibrary/TMS/EPG/H/Sml/" +
                    channel.channellogourl
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src= "https://www.verizon.com/content/dam/verizon/personal/atom/loading-large.png";
              }}
              alt=""
            />
            :
            <img src={domain + "/content/dam/verizon/personal/atom/loading-large.png"} />
            }
            <span
              className="channelCloseButton Icon Icon--close"
              tabIndex="0"
              channelno={channel.channelno}
              onClick={this.closeChannelClick}
            />
          </th>
        );
      });
      var packageList = cluRedux.packageList;

      var channelProgramResults = packageList.map(pkg => {
        return (
          <tr
            packageid={pkg.packageusoc}
            tabIndex="0"
            onClick={this.packageCompareClick}
            key={pkg.packageusoc}
            className={ cluRedux.selectedPkgs.includes(pkg.packageusoc) ? "selectedPkg" : null }
          >
            <td className="channelComparePkgs">
              {pkg.packagename.replace(/&amp;/g, "&")}
              <br />
              <span>{pkg.totalchannelcount}+ Channels</span>
            </td>
            {selectedChannelPrograms.map(channel => {
              var spanIcon = "empty";
              if (channel.ispriemum === "Y") {
                channel.packagelist.includes(pkg.packageusoc)
                  ? (spanIcon = "dot")
                  : (spanIcon = "dollar");
              } else {
                channel.packagelist.includes(pkg.packageusoc)
                  ? (spanIcon = "dot")
                  : (spanIcon = "empty");
              }
              return (
                <td
                  key={pkg.packageusoc + channel.channelno}
                  className="channelCompareResult"
                >
                  <span className={spanIcon} />
                </td>
              );
            })}
          </tr>
        );
      });

      mainContent = (
        <table>
          <thead>
            <tr>
              <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                All Packages
              </th>
              {channelProgramList}
            </tr>
          </thead>
          <tbody>{channelProgramResults}</tbody>
        </table>
      );
    }

    if (this.props.channelLineupState.cluDisplay === "CLU") {
      return (
        <React.Fragment>
          <ChannelLineup
            packageid={this.props.channelLineupState.selectedPkgs} isChangeFlow={this.props.isChangeFlow} changeTarCode={ecTarCode} changeZipCode={ecZipCode}
          />
          <button onClick={this.viewMaster} className="backButton">
            <span className="Icon Icon--left-caret" />
            Back
          </button>
        </React.Fragment>
      );
    }

    return (
      <div className="modal_content" ref={this.window}>
      <Loader />
          <div className="masterMain">
            <div className="title">
              <h2 className="modalHeaderExtender">Search to Compare Fios TV Packages</h2>
            </div>

            <div className="searchBar">
              <div className="county">
                <input
                  defaultValue={this.props.channelLineupState.vhoList[0] ? 
                    this.props.channelLineupState.vhoList[0].lfaname : ""
                  }
                  className="addressInput"
                  type="text"
                  maxLength="5"
                  onChange={this.CountyOnChange}
                  style={{ marginBottom: 0, borderRight: "2px solid #d3d3d3",
                  boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.15)"}}
                  onFocus={this.inputOnFocus}
                  onBlur={this.inputOnBlur}
                  name="county"
                />
                <div
                  className="vhoList"
                  style={{
                    listStyle: "none",
                    dispaly: "block",
                    padding: "0px 0px",
                    background: "#fff",
                    overflow: "hidden",
                    //position: "absolute",
                    width: "100%"
                  }}
                >
                  {this.props.channelLineupState.multiple
                    && this.props.channelLineupState.vhoList.map(
                        (vhoList, key) => {
                          return (
                            <div key={key} className="vhoList">
                              <button
                                onClick={this.countySelection}
                                vhoname={vhoList.vhoname}
                                lfa={vhoList.lfa}
                              >
                                {vhoList.lfaname}
                              </button>
                            </div>
                          );
                        }
                      )}
                </div>
              </div>
              <AutoComplete
                getItemValue={item => item.name}
                items={this.props.channelLineupState.searchDropdown}
                onChange={this.searchChannels}
                onSelect={this.channelProgramClick}
                open={value.length > 0 && isOpen}
                wrapperStyle={{
                  width: "70%",
                  margin: "5px 0px",
                  boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.15)",
                  height: "25%"
                }}
                renderItem={(item, isHighlighted) => (
                  <div
                    style={{
                      background: isHighlighted ? "white" : "white",
                      zIndex: "10"
                    }}
                    className="searchDropdownItem"
                    onClick={this.channelProgramClick}
                    key={item.elkchannelname + item.channelid + item.programid}
                    elkchannelname={item.elkchannelname}
                  >
                    {
                      item.logourl ? 
                      <img
                      src={
                        (item.type === "C" || item.type === "P")
                          ? domain + "/content/dam/verizon/personal/cluimages/" +
                            item.logourl
                          : "https://hydracdnssl.verizon.net/ResourcesFiles/ImageLibrary/TMS/EPG/H/Sml/" +
                            item.logourl
                      }
                      alt=""
                    />
                    : <img src={domain + "/content/dam/verizon/personal/atom/loading-large.png"} />
                    }
                    {item.name}
                  </div>
                )}
                inputProps={{
                  style: { marginBottom: 0 },
                  className: "searchInput",
                  placeholder: "Search up to 4 channels or shows"
                }}
                value={this.props.channelLineupState.searchValue}
              />
            </div>
            <div className="masterBody" style={{ paddingBottom: "80px" }}>
              {message}
              {mainContent}
              {gotoCLU}
            </div>
          </div>
        
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lqState: state.loopQual,
    appState: state.app,
    channelLineupState: state.channelLineup,
    signIn: state.signIn,
    profileCart: state.ecProfileCart
  };
};
export default connect(mapStateToProps)(ChannelLineupMaster);
